(function ($) {

    $(".reviews__slider").each(function () {
        var $this = $(this);
        var Slider = new Swiper($this.find('.swiper-container')[0], {
            slidesPerView: 'auto',
            loop: false,
            spaceBetween: 10,
            watchOverflow: true,
            freeMode: true,
            mousewheel: {
                forceToAxis: true,
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            scrollbar: {
                el: ".swiper-scrollbar",
                hide: false,
                draggable: true,
            },
            breakpoints:{
                767: {
                    freeMode: false,
                    slidesPerView: 2,
                },
                968: {
                    freeMode: false,
                    slidesPerView: 3,
                    spaceBetween: 20,
                },
            }
        });
        window.onresize = function () {
            Slider.update();
        }
    });

})(jQuery);
